<template>
  <div id="zarpes-page">
    <Zarpes />
  </div>
</template>

<script>
import Zarpes from '../components/Zarpes.vue'

export default {
  name: 'ZarpesPage',
  components: {
    Zarpes
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/zarpes.vue